import React, { FC, useMemo } from 'react';
import {
  ComponentSizes,
  IconBuyButton,
  PriceBlock
} from '@front-office/app-common-cart';
import {
  Image,
  Typography
} from '@npm-registry/eapteka-ui';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../store';
import { ProductCommonCartProps } from '../../../store/products/types';
import { RecommendationProductsStore } from '../../../store/recommendationProducts/types';
import {
  addToCart,
  selectRecommendationProduct
} from '../../../store/recommendationProducts';
import { ProductId } from '../../../store/types';
import styles from './RecommendationProduct.scss';

interface RecommendationProductProps {
  id: ProductId;
}

export const RecommendationProduct: FC<
  RecommendationProductProps
> = ({ id }) => {
  const dispatch: AppDispatch = useDispatch();

  const iconBuyButtonEventsHandlers = useMemo(
    () => ({
      addCartItem: ({
        id,
        newQuantity
      }: ProductCommonCartProps) =>
        dispatch(addToCart({ id, newQuantity }))
    }),
    [id, dispatch] // eslint-disable-line
  );

  const { name, picture, price, oldPrice, unitQuantity } =
    useSelector((state: RecommendationProductsStore) =>
      selectRecommendationProduct(state, id)
    );

  return (
    <div className={styles.root}>
      <div className={styles.image}>
        <Image src={picture} alt={name} />
      </div>
      <Typography className={styles.title}>
        {name}
      </Typography>
      <div className={styles.price}>
        <PriceBlock
          options={{
            size: ComponentSizes.S,
            isMobileView: true,
            isWithLabel: false,
            isVertical: true,
            isRedValue: true,
            isWithSaleBadge: false
          }}
          id={id}
          price={price.value}
          oldPrice={oldPrice?.value}
        />
      </div>
      <div className={styles.tools}>
        <IconBuyButton
          size={ComponentSizes.S}
          id={id}
          unitQuantity={unitQuantity}
          eventsHandlers={iconBuyButtonEventsHandlers}
        />
      </div>
    </div>
  );
};
